import Dexie, { type Table } from 'dexie';
import type {
  Client,
  Commande,
  CommandePizza,
  Order,
  OrderItem,
  Pizza,
  Product,
  Session,
} from './schema';
import { SCHEMA_V1, SCHEMA_V2, SCHEMA_V3 } from './schema';
import { upgradeAddTenantId } from './migrations/v1-to-v2-tenantid';
import { upgradeAddMetierT1Tables } from './migrations/v2-to-v3-metier-t1';

export class TablierDb extends Dexie {
  products!: Table<Product, number>;
  orders!: Table<Order, number>;
  orderItems!: Table<OrderItem, number>;
  sessions!: Table<Session, number>;
  // T1 sous-ticket 1 — DATA-MODEL T1 (post-B-001)
  clients!: Table<Client, number>;
  commandes!: Table<Commande, number>;
  commandePizzas!: Table<CommandePizza, number>;
  pizzas!: Table<Pizza, number>;

  constructor(name = 'tablier') {
    super(name);

    // Version 1 : forme initiale sans tenantId. Conservée pour rendre la migration
    // testable (un client qui aurait ouvert une v1 doit pouvoir migrer en v2 sans perte).
    this.version(1).stores(SCHEMA_V1);

    // Version 2 : ajout tenantId + index composites + backfill non destructif.
    this.version(2).stores(SCHEMA_V2).upgrade(upgradeAddTenantId);

    // Version 3 : ajout 4 tables métier T1. SCHEMA_V3 redéclare SCHEMA_V2 byte-exact
    // (sinon Dexie supprime les stores omises) + 4 nouvelles tables vides à l'init.
    this.version(3).stores(SCHEMA_V3).upgrade(upgradeAddMetierT1Tables);
  }
}

let _db: TablierDb | null = null;

export function getDb(): TablierDb {
  if (!_db) _db = new TablierDb();
  return _db;
}

// Override l'instance globale — utilisé par les tests pour pointer vers
// une DB nommée unique par run, et par un éventuel runtime qui voudrait
// injecter une instance préconfigurée.
export function setDb(instance: TablierDb): void {
  _db = instance;
}

export async function closeDb(): Promise<void> {
  if (_db) {
    _db.close();
    _db = null;
  }
}

export type {
  Client,
  Commande,
  CommandePizza,
  Order,
  OrderItem,
  OrderStatus,
  Pizza,
  Product,
  Session,
  StatutCommande,
  Tenanted,
} from './schema';
